var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 618,
    viewBox: "0 0 622 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.349 69.8269C566.482 119.399 605.848 187.196 617.512 259.367C629.176 332.267 613.867 408.083 575.959 470.048C538.78 532.013 479.002 580.127 411.934 602.726C344.137 625.325 269.779 623.138 210.001 593.978C150.952 565.547 107.212 510.143 66.388 448.907C25.564 387.671 -11.615 320.603 4.42301 268.115C19.732 214.898 88.987 176.99 148.036 128.147C207.085 78.5749 255.928 18.7969 317.893 4.21689C379.129 -10.3631 453.487 20.2549 510.349 69.8269Z",
    fill: "url(#paint0_linear_18_252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_252",
    x1: 0.60751,
    y1: 617.978,
    x2: 618.006,
    y2: -2.74544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA81F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/blob 1.47c3047cc09a6361e6fc574b4e4c1afe.svg";
export { ForwardRef as ReactComponent };